import services from '@/services/ascentiaServiceIndex'
import { PLOT_CONSTS as PLC } from '../consts'

const state = {
  plots: [],
  plotImageSrc: '',
  plotServerId: null,
  savedPagePlots: [],
  savedChartData: [],
}

const mutations = {
  [PLC.UPDATE_PLOTS]: (state, data) => (state.plots = data),
  [PLC.UPDATE_PLOT_IMAGE_SRC]: (state, data) => (state.plotImageSrc = data),
  [PLC.UPDATE_SAVE_SERVER_ID]: (state, data) => (state.plotServerId = data),
  [PLC.UPDATE_PAGE_PLOTS]: (state, data) => (state.savedPagePlots = data),
  [PLC.UPDATE_CHART_DATA]: (state, data) => (state.savedChartData = data),
}

const actions = {
  async [PLC.GET_PLOTS]({ commit }) {
    const response = await services.plot.getData('plots', {}, true)
    const plots = response.data.map(item => {
      const updatedItem = item
      updatedItem.serverId = item.serverId || item.id
      updatedItem.createdId = item.createdId || item.id

      return {
        ...updatedItem,
        isDeleting: false,
      }
    })

    const filteredPlots = plots.filter(
      plot => plot.maintenanceIssueIds.length === 0,
    )

    commit(PLC.UPDATE_PLOTS, filteredPlots)
  },

  async [PLC.GET_PLOT_IMAGE_SRC]({ commit }, serverId) {
    const response = await services.plot.getData('plotImageSrc', serverId, true)
    commit(PLC.UPDATE_PLOT_IMAGE_SRC, response.data)
  },

  async [PLC.SAVE_PLOT]({ commit, dispatch }, savePagePlot) {
    // update plot which will be passed to endpoint
    const plot = {
      id: savePagePlot.pagePlot.serverId,
      name: savePagePlot.pagePlot.title,
      plotTypeId: savePagePlot.plotTypeId ? savePagePlot.plotTypeId : 1,
      json: JSON.stringify(savePagePlot.pagePlot),
      imageSource: savePagePlot.imageSrc,
      basePlotId: savePagePlot.pagePlot.serverId,
      isActive: true,
      callGetPlots: Object.prototype.hasOwnProperty.call(
        savePagePlot,
        'callGetPlots',
      )
        ? savePagePlot.callGetPlots
        : true,
    }

    // call save plots endpoint
    const response = await services.plot.saveData('plots', plot)
    // after posting a new plot
    if (response.status === 201) {
      const basePlotId = response.headers.location.split('/').pop()
      commit(PLC.UPDATE_SAVE_SERVER_ID, basePlotId)
      if (plot.callGetPlots) {
        dispatch(PLC.GET_PLOTS)
      }
      return basePlotId
    }
    // updating an existing plot
    if (response.status === 200) {
      commit(PLC.UPDATE_SAVE_SERVER_ID, plot.basePlotId)
      if (plot.callGetPlots) {
        dispatch(PLC.GET_PLOTS)
      }
      return plot.basePlotId
    }
  },

  async [PLC.DELETE_PLOT]({ dispatch }, serverId) {
    await services.plot.deleteData('plots', serverId)
    dispatch(PLC.GET_PLOTS)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
